import { Component, forwardRef, Input, Provider } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { AFTER, sharedConfigPositionType, SharedConstants } from '@app/eds/constants';

import { TextType } from '../text';

const CUSTOM_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SlideToggleComponent),
  multi: true
};

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  providers: [CUSTOM_VALUE_ACCESSOR]
})
export class SlideToggleComponent implements ControlValueAccessor {
  // custom class to apply style for slide toggle
  @Input() customClassName: string | string[] = SharedConstants.EMPTY_STRING;

  // label for slide toggle
  @Input() public label!: string;

  // arial label for slide toggle
  @Input() public ariaLabel!: string;

  // style for slide toggle
  @Input() public textStyleType!: TextType;

  // position for label slide toggle
  @Input() public labelPosition = AFTER as sharedConfigPositionType;

  // check slide toggle use custom template or not
  @Input() public isCustomTemplate: boolean = false;

  //The internal data model
  private _value: boolean = false;

  private isDisabled: boolean = false;

  //Placeholders for the callbacks which are later providesd
  //by the Control Value Accessor
  private onTouched: () => void = () => { };
  private onChange: (value: any) => void = () => { };

  //get accessor
  get value(): boolean {
    return this._value;
  }

  // get state disable field
  get disabled(): boolean {
    return this.isDisabled;
  }

  //set accessor including call the onchange callback
  set value(newValue: boolean) {
    if (newValue !== this._value) {
      this._value = newValue;
      this.onChange(newValue);
    }
  }

  // toggle value
  toggleValue() {
    this._value = !this._value;
    this.onTouched();
    this.onChange(this._value);
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this._value) {
      this._value = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
